/* Local anchors only; no form submission or commerce interception. */
if (!customElements.get('gmox-content')) {
  customElements.define('gmox-content', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.anchors = [...this.querySelectorAll('[data-category-anchor]')];
      this.targets = this.anchors.map(link => document.getElementById(link.hash.slice(1)));
      this.update = () => {
        const header = document.querySelector('.site-header');
        const style = header && getComputedStyle(header);
        const rect = header && header.getBoundingClientRect();
        const offset = rect && ['sticky', 'fixed'].includes(style.position) ? Math.max(0, rect.bottom) + 16 : 16;
        this.style.setProperty('--gmox-content-offset', `${offset}px`);
        let active = 0;
        this.targets.forEach((target, index) => { if (target && target.getBoundingClientRect().top <= offset + 30) active = index; });
        this.anchors.forEach((link, index) => { if (index === active) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); });
      };
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); }); };
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      this.update();
    }
    disconnectedCallback() { this.controller?.abort(); cancelAnimationFrame(this.frame); }
  });
}
